import {FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";
import {FigmaElement} from "@/includes/fig-parser/models/base/figma-element";

export class FigmaVector extends FigmaElement {
  type = FIG_PARSED_FIELD_TYPES.VECTOR;
}
